import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';

import { useCustomerContext } from '../../customer.context';
import * as css from '../../customer.module.scss';
import { BankCardComponent } from '../bank-card/bank-card.component';
import { HolderCardComponent } from '../holder-card/holder-card.component';
import { InformationCard } from '../information-card/information-card';
import { InvoicingCard } from '../invoicing-card/invoicing-card.component';
import { SubscriptionCard } from '../subscription-card/subscription-card.component';

export const InformationTabView = (): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const customer = useCustomerContext();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <div className={css.customerDetails}>
      <Stack gap={GapEnum.L} direction="column" flex={1}>
        <InformationCard holder={customer.holder} />
        <HolderCardComponent
          email={customer.holder.email}
          firstName={customer.holder.firstName}
          lastName={customer.holder.lastName}
        />
        <SubscriptionCard subscriptionName={customer.subscription.name} />
      </Stack>
      <Stack gap={GapEnum.L} direction="column">
        <InvoicingCard
          billingDetails={customer.billingDetails}
          commissionPercentage={customer.commissionPercentage}
        />
        <BankCardComponent billingDetails={customer.billingDetails} />
      </Stack>
    </div>
  );
};
